import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "element-loading-text": "正在提交数据，请稍后。" }
const _hoisted_2 = {
  class: "vo-ft-pry",
  style: {"font-weight":"700"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 元 ")
const _hoisted_4 = {
  class: "vo-ft-pry",
  style: {"font-weight":"700"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 元 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("审批中")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("待支付")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("已支付")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("异常")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("退回")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("合同附件")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("付款申请附件")
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("审批批示")
const _hoisted_15 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 同意 ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 拒绝 ")
const _hoisted_18 = {
  key: 1,
  style: {"text-align":"right"}
}
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 关闭 ")

import { unref, ref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { nextTick } from 'process';

/* Componetns */
import { GbDialog } from '@/components/GbDialog/Index';

/* Apis */
import { GetBillDetailApi, BillAuditAgreeApi, BillAuditRejectApi } from '../../../apis/ct_bills/bill.api';
import moment from 'moment';
import { BillAuditDto } from '../../../apis/ct_bills/bill.dto';
import { useDictionary } from '@/store/dictionary.store';

import BillMaterialList from '@/views/contracts/detail/components/billmateriallist.vue';
import MaterialList from '@/views/contracts/detail/components/materiallist.vue';


export default /*#__PURE__*/_defineComponent({
  emits: ["success"],
  setup(__props, { expose, emit: $emits }) {



const billmateriallistRef = ref<InstanceType<typeof BillMaterialList>>(); // 付款申请附件
const materiallistRef = ref<InstanceType<typeof MaterialList>>(); // 合同附件

const detail = ref<any>()
const { getName } = useDictionary();

const auditSchema = reactive<BillAuditDto>({
    id: '',
    revision: '',
    remark: ''
})

const state = reactive({
    loading: false,
    showDialog: false,
    isPreview: false,
})

/* 获取任务项 */
const showDialog = async (rowId: string, isPreview: boolean) => {

    state.isPreview = isPreview

    const { succeeded, errors, data } = await GetBillDetailApi(rowId)

    if (!succeeded) {
        ElMessage.error(errors)
    } else {
        detail.value = data

        auditSchema.id = data.id
        auditSchema.revision = data.revision
        nextTick(() => {
            console.log(unref(billmateriallistRef))
            unref(billmateriallistRef).setFileList(rowId);
            unref(materiallistRef).setFileList(data.contract_id);
        });

        state.showDialog = true
    }

}

const btnAciotns = {
    /* 同意 */
    agree: async () => {
        state.loading = true

        const { succeeded, errors } = await BillAuditAgreeApi(auditSchema)

        state.loading = false

        if (!succeeded) {
            ElMessage.error(errors)
        }
        else {
            ElMessage.success("提交成功")

            state.showDialog = false
            $emits('success')
        }
    },

    /* 拒绝 */
    rejects: async () => {
        state.loading = true

        const { succeeded, errors } = await BillAuditRejectApi(auditSchema)

        state.loading = false

        if (!succeeded) {
            ElMessage.error(errors)
        }
        else {
            ElMessage.success("提交成功")

            state.showDialog = false
            $emits('success')
        }
    }
}

expose({ showDialog })

return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).showDialog,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).showDialog) = $event)),
    title: _unref(state).isPreview ? '付款项明细' : '付款项审批',
    style: {"width":"800px"}
  }, {
    footer: _withCtx(() => [
      (!_unref(state).isPreview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_component_el_button, {
              type: "primary",
              disabled: _unref(state).loading,
              style: {"width":"80px"},
              onClick: btnAciotns.agree
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]),
            _createVNode(_component_el_button, {
              type: "danger",
              disabled: _unref(state).loading,
              style: {"width":"80px"},
              onClick: btnAciotns.rejects
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(_component_el_button, {
              type: "info",
              disabled: _unref(state).loading,
              style: {"width":"80px"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(state).showDialog = false))
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }, 8, ["disabled"])
          ]))
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_descriptions, {
          size: "small",
          title: `付款单号：${detail.value.bill_no}，金蝶单据类型：${_unref(getName)('kingdee_type',detail.value.kingdee_type) || '付款申请'}`,
          column: 3,
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, {
              label: "申请人",
              "label-align": "center"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(detail.value.sub_emp_name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "申请部门",
              "label-align": "center"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(detail.value.sub_emp_dept), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "申请时间",
              "label-align": "center"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(moment)(detail.value.sub_date).format("YYYY-MM-DD HH:mm")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "合同编号",
              "label-align": "center"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(detail.value.contract_no), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "合同名称",
              "label-align": "center",
              span: 2
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(detail.value.contract_name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "计划名称",
              "label-align": "center",
              span: 3
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(detail.value.plan_name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "计划付款金额",
              "label-align": "center",
              span: 3
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(detail.value.plan_amount.toLocaleString('zh')), 1),
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "本次申请金额",
              "label-align": "center",
              span: 3
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(detail.value.amount.toLocaleString('zh')), 1),
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "付款备注",
              "label-align": "center",
              span: 3
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(detail.value.pay_remark), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "款项类型",
              "label-align": "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tag, {
                  type: "primary",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(detail.value.pay_type), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "付款方式",
              "label-align": "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tag, {
                  type: "primary",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(detail.value.is_split_cn), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "状态",
              "label-align": "center"
            }, {
              default: _withCtx(() => [
                (detail.value.pay_status == 1)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      size: "small",
                      type: "warning"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (detail.value.pay_status == 2)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      size: "small",
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (detail.value.pay_status == 3)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 2,
                      size: "small",
                      type: "success"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (detail.value.pay_status == 4)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 3,
                      size: "small",
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (detail.value.pay_status == 5)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 4,
                      size: "small",
                      type: "info"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "结算方式",
              "label-align": "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tag, { size: "small" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getName)('pay_method',detail.value.pay_method)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "费用项目",
              "label-align": "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tag, { size: "small" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getName)('pay_item',detail.value.pay_item)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "发票号码",
              "label-align": "center"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(detail.value.invoice_no), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "收款银行",
              "label-align": "center",
              span: 3
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(detail.value.bank_name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "收款银行地址",
              "label-align": "center",
              span: 3
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(detail.value.bank_address), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "收款账号",
              "label-align": "center",
              span: 3
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(detail.value.bank_account), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_descriptions_item, {
              label: "收款账号名称",
              "label-align": "center",
              span: 3
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(detail.value.bank_account_name), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_el_divider, { "content-position": "center" }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(MaterialList, {
          ref_key: "materiallistRef",
          ref: materiallistRef
        }, null, 512),
        _createVNode(_component_el_divider, { "content-position": "center" }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(BillMaterialList, {
          ref_key: "billmateriallistRef",
          ref: billmateriallistRef
        }, null, 512),
        (!_unref(state).isPreview)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_component_el_divider, { "content-position": "center" }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }),
              _createVNode(_component_el_form, { model: _unref(auditSchema) }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { prop: "remark" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                type: "textarea",
                                modelValue: _unref(auditSchema).remark,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(auditSchema).remark) = $event)),
                                rows: "4",
                                "show-word-limit": "",
                                maxlength: "150"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})